import { NgModule } from '@angular/core';
import { VideosComponent } from './videos.component';
import { VideosModalModule } from './modals/videos-modal.module';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/imagetools/plugin';
import { BaseModule } from '../../shared/base.module';
import { baseUrl } from '../../../environments/environment';
import { SharedPopoverModule } from '../../shared/popover/popover.module';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DialogModule } from '../../dialog/dialog.module';
import { BreadcrumbModule } from '../../shared/breadcrumb/breadcrumb.module';
import { VideosService } from './videos.service';

@NgModule({
    imports: [
        BaseModule,
        VideosModalModule,
        SharedPopoverModule,
        RouterModule,
        DialogModule,
        DragDropModule,
        BreadcrumbModule
    ],
    declarations: [
        VideosComponent
    ],
    providers: [
        VideosService
    ]
})
export class VideosModule {
}
